module.exports = __webpack_public_path__ + "static/media/form_img.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/form_img.svg
// module id = 72
// module chunks = 0